import axios from "axios";
import {WOKRFLOW_API_HOST} from "@/core/variables";
import {NoticeBase} from "@/model/alarm/Notice";

class AlarmRepository {

    async sendNotice(props: NoticeBase) {
        return axios.post(`${WOKRFLOW_API_HOST}/internal/v1/alarms/notice`, props)
    }

    async getSendNoticeHistory() {
        return axios.get(`${WOKRFLOW_API_HOST}/internal/v1/alarms/notice-history`);
    }
}
const alarmRepository = new AlarmRepository();
export default alarmRepository;
